<template>
  <div class="floating-dropup-box">
    <div class="dropup floating-dropup" v-bind:class="{ show: visible }">
      <button class="btn btn-primary rounded-circle menu-toggle" v-on:click="toggleMenu">
        <i class="material-icons" v-show="visible">close</i>
        <i class="material-icons" v-show="!visible">add</i>
      </button>
      <div class="dropdown-menu dropdown-menu-right">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import clickout from '../mixins/clickout';

  export default {
    name: 'floating-dropup',

    mixins: [
      clickout,
    ],

    data() {
      return {
        visible: false,
      };
    },

    watch: {
      visible(state, old) {
        if (state === old) {
          // Avoid duplicated emits
          return;
        }

        if (state) {
          this.$root.$emit('shown::dropdown', this);
        } else {
          this.$root.$emit('hidden::dropdown', this);
        }
      },
    },

    methods: {
      toggleMenu() {
        this.visible = !this.visible;
      },

      clickOutListener() {
        this.visible = false;
      },

      click() {
        this.toggleMenu();
      },
    },

    created() {
      this.$root.$on('shown::dropdown', (el) => {
        if (el !== this) {
          this.visible = false;
        }
      });
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/FloatingDropup.vue